import { getTaxonomyFullName } from '@app/utils/taxonomyUtils';
import { Typography } from '@mui/material';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface TaxonomyBreadCrumbProps {
  selectedTaxonomy: GenericObject | null;
}

export const TaxonomyBreadCrumb = ({ selectedTaxonomy }: TaxonomyBreadCrumbProps) => {
  return (
    <div>
      <Typography sx={{ fontSize: '16px' }} color="text.secondary" gutterBottom>
        {getTaxonomyFullName(selectedTaxonomy)}
      </Typography>
    </div>
  );
};
